import React, { useState } from 'react'
import Tippy from '@tippyjs/react'
import { CopyToClipboard } from 'react-copy-to-clipboard'

function Copy(props) {
  const { children } = props
  const [copied, setCopied] = useState(false)
  return (
    <Tippy content={copied ? 'Copied!' : 'Copy to clipboard'}>
      <div className="inline">
        <CopyToClipboard text={children} onCopy={() => setCopied(true)}>
          <span className="bg-purple-100 select-all text-sm p-1 cursor-pointer break-words">
            {children}
          </span>
        </CopyToClipboard>
      </div>
    </Tippy>
  )
}

export default Copy
